import * as THREE from 'three';
import type { SceneObject } from '../sceneObject';
import { SelectableObject } from '../selectableObject';
import type { SelectionViewportRect } from '../tools/selectMarqueeTool';
import { deselectAll } from '@/stores/selectionStore';

export class MarqueeViewportSelector {
  private readonly scratchBounds = new THREE.Box3();

  selectContainedObjects(
    sceneObjects: SceneObject<any>[],
    camera: THREE.Camera,
    viewportRect: DOMRect,
    selectionRect: SelectionViewportRect,
  ) {
    deselectAll();

    for (const sceneObject of sceneObjects) {
      if (!(sceneObject instanceof SelectableObject)) {
        continue;
      }

      if (
        this.isObjectFullyContainedInViewportRect(
          sceneObject,
          camera,
          selectionRect,
          viewportRect,
        )
      ) {
        sceneObject.select();
      }
    }
  }

  private isObjectFullyContainedInViewportRect(
    sceneObject: SelectableObject,
    camera: THREE.Camera,
    selectionRect: SelectionViewportRect,
    viewportRect: DOMRect,
  ) {
    const worldBounds = sceneObject.getWorldAabb(this.scratchBounds);
    const min = worldBounds.min;
    const max = worldBounds.max;

    const corners = [
      new THREE.Vector3(min.x, min.y, min.z),
      new THREE.Vector3(min.x, min.y, max.z),
      new THREE.Vector3(min.x, max.y, min.z),
      new THREE.Vector3(min.x, max.y, max.z),
      new THREE.Vector3(max.x, min.y, min.z),
      new THREE.Vector3(max.x, min.y, max.z),
      new THREE.Vector3(max.x, max.y, min.z),
      new THREE.Vector3(max.x, max.y, max.z),
    ];

    for (const corner of corners) {
      corner.project(camera);

      if (corner.z < -1 || corner.z > 1) {
        return false;
      }

      const viewportX =
        viewportRect.left + (corner.x + 1) * 0.5 * viewportRect.width;
      const viewportY =
        viewportRect.top + (1 - (corner.y + 1) * 0.5) * viewportRect.height;

      if (
        viewportX < selectionRect.left ||
        viewportX > selectionRect.right ||
        viewportY < selectionRect.top ||
        viewportY > selectionRect.bottom
      ) {
        return false;
      }
    }

    return true;
  }
}
